import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { AnalyticsSearchEventProvider } from '../providers/search-event-provider';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[searchEvent]',
  standalone: true,
})
export class SearchEventDirective {
  private readonly provider = inject(AnalyticsSearchEventProvider);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  @HostListener('change', ['$event'])
  protected onMouseUp(event: Event): void {
    const inputElement = this.getInputElement(this.elementRef.nativeElement);
    if (!inputElement) return;

    this.provider.createAndPush({
      element: inputElement,
    });
  }

  private getInputElement(parent: HTMLElement): HTMLInputElement | undefined {
    if (parent.tagName === 'INPUT' && parent instanceof HTMLInputElement) {
      return parent;
    }

    return parent.querySelector('input') as HTMLInputElement | undefined;
  }
}
